module.exports = __webpack_public_path__ + "img/logo.8e8a0f6c.png";